<template>
    <div class='game-bg'>
        <el-image :src="game_header" style=" width: 100%; margin-bottom: 3%"></el-image>
        <div class='game-list'>
<!--            <div class="game-item" v-for="game in game_list" :key='game.url'>-->
<!--                <el-image :src="game.url" class="game-img"></el-image>-->
<!--            </div>-->
            <div class="game-item" v-for="game in game_list" :key='game.url'>
                <div class="el-image game-img">
                    <img :src="game.url" class="el-image__inner">
                    <!-- <div class="download-group">
                        <img src="../assets/img_grande/download_google.png" alt="" class="download-btn">
                        <img v-if="game.ios_url" src="../assets/img_grande/download_ios.png" alt="" class="download-btn">
                        <img v-if="game.aws_url" src="../assets/img_grande/download_aws.png" alt="" class="download-btn">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            game_header: `${require('../assets/img_grande/head.jpg')}`,
            game_list: [
                {
                    url: `${require('../assets/img_grande/game1.png')}`,
                    ios_url: true,
                    aws_url: true,
                    name: 'CF'
                },
                {
                    url: `${require('../assets/img_grande/game2.png')}`,
                    ios_url: true,
                    aws_url: true,
                    name: 'LS'
                },
                {
                    url: `${require('../assets/img_grande/game3.png')}`,
                    ios_url: true,
                    aws_url: true,
                    name: 'DF'
                },
                {
                  url: `${require('../assets/img_grande/game4.png')}`,
                  ios_url: true,
                  aws_url: true,
                  name: 'AF'
                },
                {
                  url: `${require('../assets/img_grande/game5.png')}`,
                  ios_url: true,
                  aws_url: true,
                  name: 'BF'
                },

            ]
            // game_list: [
            //     {
            //         url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_1.png',
            //     },
            //     {
            //         url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_2.png',
            //     },
            //     {
            //         url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_3.png',
            //     },
            //     {
            //         url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_4.png',
            //     },
            // ]
        }
    }
}
</script>

<style lang="less">
    h1 {
        margin-top: 100px;
    }

    .game-img {
        margin-left: auto;
        margin-right: auto;
        display: block;
        margin-bottom: -6%;
        width: 70%;
    }

    .game-item {
        margin-bottom: 10%;
    }
    .download-btn {
        width: 7.5vw;
    }
    .download-group {
        width: 40%;
        position: absolute;
        bottom: 20px;
        left: 36%;
        a {
            cursor: pointer;
        }
    }

    @media screen and (max-width: 992px) {
        .game-img {
            width: 98%;
        }
        .download-group {
            width: 60%;
            position: absolute;
            bottom: 1px;
            left: 26%;
        }
        .download-btn {
            width: 13.5vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Game.vue
